























import {Vue, Component, Prop} from "vue-property-decorator";
import axios from "axios";
import {MailResendModel} from "@/model/mail.resend.model";

@Component
export default class MailResend extends Vue {

    @Prop() private isVisible!: boolean;

    mailModel: MailResendModel = new MailResendModel;

    created() {
        // メールアドレスに初期値を設定
        this.mailModel.mail = ""
    }

    resend() {
        axios.post("/email/resend-verification", this.mailModel)
            .then(cb => {
                this.$emit('close', cb.status, "");
            })
            .catch(error => {
                const {data, status} = error.response;
                this.$emit('close', status, data);
            });
    }
}
